<template>
    <div class="newDetail_liul padding80">
        <Header :current="2"></Header>
        <div class="contents">
            <div class="title">紧握直播红利，万亿级城商行与徕檬直播团队携手打造PUGC级金融直播间</div>
            <div class="time">2021-04-25 </div>
            <div class="content">据悉，徕檬直播团队协助全球银行品牌百强、某国内资产总额万亿级城商行于近两月陆续完成包括总行营业部、信用卡中心、各分支行在内数十间不同规格线下金融直播间的搭建，并已陆续完成调试、投入使用。其中，总行和信用卡中心配备PUGC级金融直播间，各分行和支行配备UGC级金融直播间。</div> 
            
            <img class="img1" src="../../assets/new/newDetail_zbhl1.png" alt="">
            <div class="content">国内直播平台及观众数量自2016年爆发以来，一直呈现井喷式发展态势。尤其在过去的2020年，“宅生活”对我国直播行业的发展产生了跨越式的推动。“全民直播”时代随之来临，网络直播市场达到历史新高，网络直播观众规模在2020年末已突破6亿人。</div>
            <div class="content2">拥抱变化，敢为人先。金融直播间的搭建对于银行业务的发展具有重大意义。</div>
            <div class="content2">金融直播间对客可用于权益“带货”、营销金融产品服务、科普理财知识，持续为业务发展聚能赋能，以进一步扩大营收；对内可组织员工会议、宣讲、培训等，提升行内工作效率。</div>
            <div class="content2">据悉，金融直播领域走在前列的某万亿级城商行已使用全新直播间开播了大大小小近百场直播，获得了用户、员工、业内的广泛好评。</div>
            <img class="img1" src="../../assets/new/newDetail_zbhl2.png" alt="">
            <div class="content">在疫情时代下，“无接触式”金融服务逐渐成为刚需，也促进银行进一步加快了数字化转型速度。银行通过“直播”这种相对新颖的营销方式，让品牌形象更加亲民，拉近与受众距离。与此同时，直播也成为了银行履行社会责任、扩大影响力的重要方式。</div>
            <div class="content2">此次该万亿级城商行直播硬件设备解决方案由徕檬旗下徕檬直播团队提供，包含直播间规格制定、风格设计、设备采购、安装、调试等。</div>
            <div class="content2">据徕檬官网信息显示，徕檬是一家致力于金融企业数字化转型和移动互联网、人工智能赋能金融生态圈的创新型企业。徕檬直播团队隶属于徕檬，以自身的技术与运营优势，结合金融与直播领域深耕多年的丰富经验，助力多家银行及其他金融企业抢占直播流量红利，创造商业价值。</div>
            <img class="img2" src="../../assets/new/newDetail_zbhl3.png" alt="">
            <div class="content">银行如何开展金融直播业务？面对现实的业务需求，徕檬直播团队针对性地推出了集设计、制作、施工、售后服务于一体的直播硬件设备解决方案。</div>
            <div class="content2">徕檬直播团队全程参与行方直播间选址，并依据行方业务需求量身定制整套设计方案，并提供从直播设备采购、安装调试，到手把手使用教学的一站式服务。</div>
            <div class="content2">“和支行以前用手机搞的直播效果太不一样了！”某行客户经理张某和笔者说道：“以前没有专门的直播间，我们都是用手机直接在会议室里开播，手机摄像头效果不行，直播也不稳定。现在有了专业直播间，直播效果好太多。” </div>
            <img class="img1" src="../../assets/new/newDetail_zbhl4.png" alt="">
            <div class="content">这也是徕檬直播赋能银行的一贯理念。</div>
            <div class="content2">据悉，徕檬直播除提供金融直播间的设计、设备供应、调试之外，亦可同步承制直播全案（含供应链），并通过【徕檬学院】培训直播领域人才，输出直播能力。</div>
            <div class="content2">从直播硬件设备，直播全案承接到专注于直播培训的徕檬学院，徕檬直播通过完整的解决方案闭环与银行和其他金融企业一道构建多元化、差异化、高品质的服务于金融业务的直播生态体系。</div>
            <div class="content2">据进一步了解，徕檬直播未来将持续为各银行客户持续输出直播设备使用进阶培训、主播开播技巧培训等提升计划，辅助客户经理提升直播技巧，以通过金融直播业务提高用户留存、扩大营收，助力业务发展</div>
            <div class="content2">截至发稿，徕檬直播已与华夏银行、常熟农商行等银行接洽了金融直播全案解决方案。后续金融直播合作项目的进展情况笔者将持续关注报道。</div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
export default {
  name: "newDetail_liul",
  data() {
    return {};
  },
  created() {
    window, scrollTo(0, 0);
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.contents {
  width: 930px;
  margin: 0px auto;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #333333;
  margin-bottom: 50px;
  .title {
    font-size: 30 * 0.75px;
    font-weight: bold;
    margin-top: 40px;
  }
  .time {
    color: #666666;
    font-size: 14 * 0.75px;
    margin-top: 10px;
  }
  .content {
    font-size: 17 * 0.75px;
    margin-top: 40px;
    line-height:1.5em;
  }
  .content2 {
    font-size: 17 * 0.75px;
    margin-top: 10px;
    line-height:1.5em;
  }
  .img1 {
    width: 704 * 0.75px;
    height: 500 * 0.75px;
    margin-top: 30px;
  }
  .img2 {
    width: 700 * 0.75px;
    height: 200 * 0.75px;
    margin-top: 30px;
  }
}
</style>
